import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { useCookies } from "react-cookie";

import { ApplicationState } from "../../store";
import * as UserStore from "../../store/User";

type LoginState = {
  username: string;
  password: string;
  submitted: boolean;
};

type Props = UserStore.UserState & // ... state we've requested from the Redux store
  typeof UserStore.actionCreators; // ... plus action creators we've requested

const Login: React.FC<Props> = (props) => {
  const [_, setCookie] = useCookies();
  const [loginState, setLoginState] = React.useState<LoginState>({
    username: "",
    password: "",
    submitted: false,
  });

  React.useEffect(() => {
    if (
      props.loggedIn &&
      props.user.token &&
      props.user.token.length > 0 &&
      props.user.isValidToken
    ) {
      setCookie("tsToken", props.user.token);
    }
  }, [setCookie, props.loggedIn, props.user.token]);

  const loginSubmit = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();

    setLoginState({
      ...loginState,
      submitted: true,
    });

    const { username, password } = loginState;
    if (username && password) {
      props.authenticate(username, password);
    }
  };

  const onUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginState({
      ...loginState,
      username: event.target.value,
    });
  };

  const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginState({
      ...loginState,
      password: event.target.value,
    });
  };

  return props.loggedIn ? (
    <Redirect to="/admin/albums" />
  ) : (
    <div className="container">
      <div style={{ margin: "150px auto", maxWidth: 450 }}>
        <div className="row">
          <div className="col-md-12">
            <form id="loginForm" onSubmit={loginSubmit}>
              <div>
                <div className="form-group">
                  <input
                    className="form-control"
                    data-val="true"
                    data-val-required="The User name field is required."
                    id="UserName"
                    name="UserName"
                    onChange={onUserNameChange}
                    placeholder="UserName"
                    type="email"
                    value={loginState.username}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control"
                    data-val="true"
                    data-val-required="The Password field is required."
                    id="Password"
                    name="Password"
                    onChange={onPasswordChange}
                    placeholder="Password"
                    type="password"
                    value={loginState.password}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="btn btn-success"
                    type="submit"
                    value="Login"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state: ApplicationState) => state.user, // Selects which state properties are merged into the component's props
  UserStore.actionCreators // Selects which action creators are merged into the component's props
)(Login as any);
